import { getChainColors } from "./chains";

// Function to update CSS custom properties based on chain ID
export const updateChainColors = (chainId: string | number) => {
  const colors = getChainColors(chainId as number);

  // Update CSS custom properties on the root element
  const root = document.documentElement;
  root.style.setProperty("--color-primary", colors.primary);
  root.style.setProperty("--color-secondary", colors.secondary);
};

// Function to get current chain colors
export const getCurrentChainColors = (chainId: string | number) => {
  return getChainColors(chainId as number);
};

// Initialize colors on app load
export const initializeChainColors = (chainId = "10143") => {
  updateChainColors(chainId);
};
